import { query } from "@/api/query"
import { MY_SPACE } from "@/constants/spaces"
import { getRestrictionsRecap } from "@/lib/utils/space"
import type { RouterContext } from "@/router"

/**
 * A function that retrieves the restrictions recap for the current space and user.
 * Automatically ensures space and subscription data is loaded.
 *
 * @param context - Context object.
 * @returns Comprehensive restrictions and usage information
 */
export async function getRecap(context: RouterContext) {
  // Preload is currently not used, but we may need it in the future

  const spaces = await context.queryClient.query({ ...query.space.list, staleTime: "static" })
  const space = spaces.find(sp => sp.id === context.spaceStorage.getSpace()) || MY_SPACE

  return getRestrictionsRecap(
    await context.queryClient.query({ ...query.space.subscriptions(space.id), staleTime: "static" }),
    await context.queryClient.query({ ...query.space.subscriptions(MY_SPACE.id), staleTime: "static" }),
    false
  )
}
